import * as React from "react";
import { SVGProps } from "react";

const Loopring = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 23" {...props}>
    <path
      fill="#1c60ff"
      d="M17.4 11.6H30v.1l-19.7 12 9.8-7.8ZM10 0v23.9l-10-8Z"
    />
  </svg>
);

export default Loopring;
